import type React from 'react';
import ApiErrorBoundary from './ApiErrorBoundary';
import RenderErrorBoundary from './RenderErrorBoundary';

const ErrorBoundaries: React.FC<React.PropsWithChildren> = ({ children }) => {
  // order on the components matters!
  const errorBoundaryWrappers: React.FC<React.PropsWithChildren>[] = [
    RenderErrorBoundary,
    ApiErrorBoundary
  ];

  let errorBoundary: React.ReactNode = children;

  errorBoundaryWrappers.forEach(ErrorWrapper => {
    errorBoundary = <ErrorWrapper>{errorBoundary}</ErrorWrapper>;
  });

  return errorBoundary as React.ReactElement;
};

export default ErrorBoundaries;
